module.exports = __webpack_public_path__ + "static/hotcoco_logo-d551950f82a11e367b429fd6d864e7f3.png";